import { client } from '@/sanity/lib/client';
import Support from '@/src/components/screens/Support/Support';

import themeArchiveQuery from '@/src/assets/queries/themeArchiveQuery';

import { ITheme } from '../../assets/interfaces/themeInterface/index';

type THomePageProps = {
    data: ITheme[];
};

export default function SupportPage({ data }: THomePageProps) {
    return <Support themesData={data} />;
}

export async function getStaticProps() {
    const data = await client.fetch(themeArchiveQuery);

    return {
        props: {
            data: data ?? null,
        },
        revalidate: 10,
    };
}
